const ShuffleIcon = () => {
    return (
        <img
            style={{ width: '100%', height: '100%' }}
            src="/images/shuffle-icon.svg"
            alt="Document Icon"
        />
    );
};

export default ShuffleIcon;
